import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useBadDebtsList() {
  // Use toast
  const toast = useToast();

  const refBadDebtListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // { key: "id", label: "編號", sortable: true, class: 'sticky-column' },
    { key: "amount", label: "壞賬金額", class: 'sticky-column', formatter: formatCurrency },
    { key: "bad_debt_date", label: "壞賬日期", class: 'sticky-column' },
    { key: "actions", label: "操作", class: 'sticky-column' },
    // { key: "project_id", label: "項目編號", sortable: true },
    // { key: "project_name", label: "項目名稱" },
    { key: "invoice.address", label: "施工地址" },
    { key: "invoice_id", label: "發票編號", sortable: true },
    { key: "customer_id", label: "客戶", sortable: true },
    { key: "reason", label: "備註及原因", sortable: true },
    { key: "name_cn", label: "單據抬頭", sortable: true },
    { key: "name_en", label: "系統帳號名稱", sortable: true },
    { key: "mobile", label: "聯絡電話" },
    { key: "email", label: "電郵地址"},
    // { key: "notes", label: "筆記", sortable: true },
    { key: "created_at", label: "生成日期", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("bad_debt_date");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refBadDebtListTable.value
      ? refBadDebtListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });


  const refetchData = () => {
    refBadDebtListTable.value.refresh();
  };

  const badDebtsList = ref(null);

  const fetchBadDebts = (ctx, callback) => {
    store
      .dispatch("bad-debt/fetchBadDebts", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        // project_id: filter_project_id.value,
      })
      .then((response) => {
        const { bad_debts, total } = response.data;
        callback(bad_debts);
        totalRow.value = total;
        badDebtsList.value = bad_debts
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const filter_project_id = ref(null);
  const filter_customer_id = ref(null);
  const filter_invoice_id = ref(null);

  watch(
    [currentPage, perPage, searchQuery, filter_project_id, filter_customer_id, filter_invoice_id],
    () => {
      refetchData();
    }
  );

  const projectOptions = ref([]);
  const customerOptions = ref([]);
  const invoiceOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        projects: true,
        customers: true,
        invoices: true,
      })
      .then((response) => {
        projectOptions.value = response.data.projects;
        customerOptions.value = response.data.customers;
        invoiceOptions.value = response.data.invoices;
      });
  };
  onMounted(() => {
    refetchOption();
    refetchData();
  });

  return {
    fetchBadDebts,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    badDebtsList,
    refBadDebtListTable,
    refetchData,
    ability,
    refetchOption,
    filter_project_id,
    filter_customer_id,
    filter_invoice_id,
    projectOptions,
    customerOptions,
    invoiceOptions,
  };
}